import { RightMenu } from './RightMenu'

export const Comopnent = { RightMenu }
